module.exports = __webpack_public_path__ + "static/media/70.67a935de.wav";